import React from 'react'

import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import useIsMobile from '@/hooks/useIsMobile'

const EmojiPost = ({
  isOpen,
  onToggleOpen,
  onSelectIcon,
  position = 'bottom',
}: {
  isOpen: boolean
  onToggleOpen: () => void
  onSelectIcon: (v: string) => void
  position?: 'top' | 'bottom'
}) => {
  const onAddEmoji = (emoji: any) => {
    const sym = emoji.unified.split('_')
    const codesArray: any = []
    sym.forEach((el: any) => codesArray.push('0x' + el))
    const emojiIcon = String.fromCodePoint(...codesArray)
    onSelectIcon(emojiIcon)
  }
  const isMobile = useIsMobile()
  const style: any = position === 'top' ? { bottom: 20 } : { top: 20 }
  if (isMobile) {
    style.left = -50
  }
  if (!isOpen) return null
  return (
    <div className="absolute z-[51] pt-2" style={style}>
      <Picker onClickOutside={onToggleOpen} data={data} onEmojiSelect={onAddEmoji} />
    </div>
  )
}

export default EmojiPost
